import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Content, Button } from '../atoms';

function getGlobal(name) {
  if (typeof window !== 'undefined') {
    return window[name];
  }
  return null;
}

function getFlagFromLocalStrorage() {
  const globalLocalStorage = getGlobal('localStorage');
  if (!globalLocalStorage) return true;
  const flag = localStorage.getItem('hide-privacy-popup');
  return !!flag;
}

function setFlagToLocalStrorage() {
  const globalLocalStorage = getGlobal('localStorage');
  if (!globalLocalStorage) return;
  localStorage.setItem('hide-privacy-popup', true);
}

export function PrivacyPopUp({ content, button }) {
  const [hide, setHide] = useState(getFlagFromLocalStrorage);

  function onClick() {
    setFlagToLocalStrorage();
    setHide(true);
  }

  if (hide) return null;

  return (
    <div className="fixed bottom-0 w-full flex justify-center items-center">
      <div className="container mb-5 px-5 lg:px-32 xl:px-72">
        <div className="px-5 py-3 rounded-lg bg-white shadow-md flex flex-col md:flex-row justify-between items-center">
          <Content className="mb-5 md:mb-0">{content}</Content>
          <Button onClick={onClick}>{button}</Button>
        </div>
      </div>
    </div>
  );
}

PrivacyPopUp.propTypes = {
  content: PropTypes.string.isRequired,
  button: PropTypes.string.isRequired,
};
